<template>
	<div class="cghead">
		<div class="header" @click="qrcode = true">
		</div>
		<div class="goodsWrap">
			<div class="goods">

				<div class="nav">
					<ul class="layui-nav" lay-filter="">
						<li class="layui-nav-item" id="address" style=""><a>长期居住地-{{address}}</a></li>
						<li class="layui-nav-item" :class="province == '全部' ? 'navActive' : ''"><a
								@click="change('全部')">全部</a></li>
						<li class="layui-nav-item" :class="province == '北京' ? 'navActive' : ''"><a
								@click="change('北京')">北京</a></li>
						<li class="layui-nav-item" :class="province == '上海' ? 'navActive' : ''"><a
								@click="change('上海')">上海</a></li>
						<li class="layui-nav-item" :class="province == '广东' ? 'navActive' : ''"><a
								@click="change('广东')">广东</a></li>
						<li class="layui-nav-item" :class="province == '四川' ? 'navActive' : ''"><a
								@click="change('四川')">四川</a></li>
						<li class="layui-nav-item" :class="province == '浙江' ? 'navActive' : ''"><a
								@click="change('浙江')">浙江</a></li>
						<li class="layui-nav-item" :class="province == '江苏' ? 'navActive' : ''"><a
								@click="change('江苏')">江苏</a></li>
						<li class="layui-nav-item" :class="province == '湖南' ? 'navActive' : ''"><a
								@click="change('湖南')">湖南</a></li>
						<!-- <li class="layui-nav-item fr"><a>更多<i class="el-icon-arrow-down"></i></a></li> -->
					</ul>
					<div class="popover-box">
						<el-popover popper-class="el-popoverss" placement="bottom-end" trigger="hover"
							:visible-arrow="false">
							<div style="width:19rem;">
								<span>热门</span>
								<div class="province_box">
									<el-row :gutter="8">
										<el-col :span="4.8">
											<div class="grid-content bg-purple province_item" @click="change('北京')">
												北京
											</div>
										</el-col>
										<el-col :span="4.8">
											<div class="grid-content bg-purple province_item" @click="change('上海')">
												上海
											</div>
										</el-col>
										<el-col :span="4.8">
											<div class="grid-content bg-purple province_item" @click="change('广东')">
												广东
											</div>
										</el-col>
										<el-col :span="4.8">
											<div class="grid-content bg-purple province_item" @click="change('江苏')">
												江苏
											</div>
										</el-col>
										<el-col :span="4.8">
											<div class="grid-content bg-purple province_item" @click="change('四川')">
												四川
											</div>
										</el-col>

									</el-row>
								</div>
								<span>全部</span>
								<div class="province_box">
									<el-row :gutter="8">
										<el-col :span="4.8" v-for="(item,index) in provinceList" :key="index">
											<div class="grid-content bg-purple province_item" @click="change(item)">
												{{item}}
											</div>
										</el-col>
									</el-row>
								</div>
							</div>
							<template slot="reference">
								<div style="color:#8f8f91;">
									<span>
										更多
									</span>
									<i class="el-icon-caret-bottom"></i>
								</div>
							</template>

						</el-popover>

					</div>
				</div>

				<div class="goodsBox" id="pro">
					<h1 styple="margin:200px auto;" v-if="productList.length == 0">
						正在努力加载您的优惠价格...
					</h1>
					<template v-else>
						<div class="gooditem" v-for="(item,index) in productList">
							<img :src="item.BgImgPath" />
							<div class="goodbottom">
								<div class="goodsL">
									<div class="goodtitle" :title="item.VisaTitle">{{item.VisaTitle}}</div>
									<div class="price">￥{{item.Price1}}</div>
								</div>
								<div class="goodsR">
									<el-button type="warning" size="medium" round
										@click="goLink('/detail?id=' + item.CountryId + '&County=' + item.CountryName + '&detail=' + item.Id)">
										立即抢购</el-button>
								</div>
							</div>
						</div>
					</template>

				</div>
			</div>
		</div>
		<div class="maks" v-if="qrcode">
			<div class="qrcode">
				<div class="qrcode-title">优惠券抽奖</div>
				<i class="el-icon-close" @click="qrcode = false"></i>
				<img src="https://www.aavisa.com/Content/Images/qrcode.png" />
			</div>
		</div>


	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				address: '广东',
				province: '全部',
				productList: [],
				provinceList: ['全部', '北京', '上海', '广东', '四川', '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽',
					'福建', '江西', '山东', '河南',
					'湖北', '湖南', '广西', '海南', '重庆', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '台湾', '香港', '澳门'
				],
				qrcode:false,
			}
		},
		created() {

		},
		mounted() {
			this.getAddress()
		},
		methods: {
			getAddress() {
				axios.get('https://photo.aavisa.com/app_api/v1/auth/getipdata')
					.then(response => {
						console.log('获取数据成功', JSON.parse(response.data.data));
						let res = JSON.parse(response.data.data)
						if (res.ret = 'ok') {
							this.address = res.data[1]
							this.province = res.data[1]
						}
						this.getHotProduct()
					}).catch(err => {
						this.getHotProduct()
					})
			},

			change(name) {
				this.province = name
				this.getHotProduct()
			},

			changeProvince() {},

			getHotProduct() {
				let ShengName = this.province;
				this.$api.GetHotProduct({
					ShengName: ShengName == '全部' ? '' : ShengName
				}).then(res => {
					console.log(res);
					let {
						result,
						data
					} = res.data;
					this.productList = data.DataList;
				})

			},

			goLink(url) {
				this.$router.push(url)
			},
		}
	}
</script>

<style lang="less" scoped>
	@import "./PcProduct.css";

	.maks {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, .8);
	}

	.qrcode {
		width: 300px;
		height: 300px;
		background-color: #FFF;
		border-radius: 10px;
		// position: relative;
		top: calc(50% - 150px);
		left: calc(50% - 150px);
		position: absolute;
		z-index: 10000;
		.el-icon-close{
			position: absolute;
			top: 10px;
			right: 10px;
			font-size: 25px;
			cursor: pointer;
		}
		.qrcode-title{
			margin-top: 16px;
			font-size: 18px;
		}
		&>img {
			width: 200px;
			height: 200px;
			position: absolute;
			top: calc(50% - 80px);
			left: calc(50% - 100px);
		}
	}

	.popover-box {
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translate(0%, -50%);
	}

	.cghead {
		// background-image: url('https://file.aavisa.com/browser-upload-file/a717746c-8f4b-434f-ae7d-b3fec356d8b9.jpg');
		background-repeat: no-repeat;
		background-size: contain;
		width: 1120px;
		// min-height: 332px;
		margin: 0 auto;
	}

	.nav {
		height: 60px;
		padding: 0 20px;
		background-color: #393d49;
		position: relative;

		.navActive {
			&>a {
				color: #c3c3c3 !important;
			}
		}

		.layui-nav {
			display: flex;
			height: 100%;
			align-items: center;

			&>li {
				margin-right: 20px;

				&>a {
					color: #8f8f91;
				}
			}

			.fr {
				margin-left: auto;
			}
		}
	}

	.positionList {
		width: 880px;
		margin: 0 154px;
		height: 92px;
	}

	.positionList ul li.active span {
		padding: 3px 10px;
		border: 1px solid #757575;
		border-radius: 15px;
		margin-left: -11px;
		color: #df4630;
	}

	.positionList ul li.active i {
		display: inline-block;
		height: 9px;
		width: 12px;
		background: url(/Content/Images/Web/i1.png);
		margin-left: 5px;
		margin-bottom: 1px;
	}

	.header {
		width: 1120px;
		height: 371px;
		background-size: cover;
		background-repeat: no-repeat;
		margin: 0px auto;
		background-image: url(https://file.aavisa.com/browser-upload-file/a717746c-8f4b-434f-ae7d-b3fec356d8b9.jpg);
	}

	.goodsWrap {
		width: 1120px;
		margin: 0px auto;
		// padding-top: 332px;
	}

	.goodsBox {
		margin: 0 auto;
		padding-top: 0px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		width: 100%;
	}

	.goodtitle {
		height: 40px;
		/* white-space: nowrap; */
		text-align: left;
		line-height: 20px;
		max-width: 212px;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.gooditem {
		min-width: 257px;
		height: 267px;
		margin: 10px 3px;
		/* border: 1px solid #000; */
		/* padding: 0px 10px; */
		border-radius: 8px;
	}

	.gooditem img {
		width: 344px;
		/* height: 60%; */
		border-radius: 5px;
	}

	.goods {
		width: auto;
		background: none;
		box-shadow: none;
		padding-bottom: 50px;
	}

	.goodbottom {
		background: white;
		display: flex;
		align-items: center;
		padding: 5px;
		border-radius: 0px 0px 8px 8px;
	}

	.goodsL {
		width: 70%;
		line-height: 40px;
	}

	.price {
		color: #ff5722;
		font-size: 15px;
		font-weight: bold;
		text-align: left;
	}

	.header .stamp {
		position: relative;
		left: 500px;
		top: 500px;
	}

	.positionC {
		width: 250px;
		height: 50px;
		padding: 14px 24px;
		border: 1px solid #6f6f6f;
		margin: 0 auto;
		font-size: 22px;
		line-height: 24px;
		border-radius: 2px;
		overflow: hidden;
		color: #787878;
	}

	.goodsIntro img {
		display: inline;
	}

	.im {
		width: 17px;
		margin-bottom: 3px;
	}

	.hr {
		background-color: #df4630;
		border: 0 none;
		height: 3px;
		margin: 26px 0;
		width: 64px;
	}

	.goodsList .btn1 {
		/*background: #d9534f;*/
		border: 1px solid #df4630;
		border-radius: 5px;
		bottom: 18px;
		color: #df4630;
		font-size: 16px;
		height: 34px;
		line-height: 34px;
		position: absolute;
		right: 0;
		text-align: center;
		width: 120px;
	}

	.lsa {}

	.lis {
		/*display: block;
	        overflow: hidden;
	        word-break: keep-all;
	        word-wrap: normal;
	        text-overflow: clip;
	        width:32px;*/
	}

	.mod_tit_line {
		border-top: 2px solid #df4630;
		text-align: center;
		height: 6px;
		width: 336px;
		margin: 0 auto;
	}

	.mod_tit_line h3 {
		position: relative;
		display: inline-block;
		font-size: 30px;
		height: 12px;
		line-height: 12px;
		top: -30px;
		padding: 0 20px;
		background: #fff;
		color: #292524;
	}

	img#img1 {
		margin: 0px auto;
		margin-top: 0px;
		margin-right: auto;
		margin-bottom: 0px;
		margin-left: auto;
	}

	.class-layer-demo-custom1 .layui-layer-content {
		overflow: inherit !important;
	}

	.province_item {
		width: 3rem;
		height: 1.35rem;
		/* border: 1px solid #599fff; */
		background-color: #fcfcfc;
		color: rgb(151, 151, 151);
		border: rgb(151, 151, 151) 1px solid;
		margin-bottom: 0.425rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		cursor: pointer;
		margin-left: 0.2rem;
	}

	.province_box {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}
</style>
<style>
	.el-popoverss {
		left: 86.4375rem !important;
		transform: translate(0, 0rem);
	}
</style>



// WEBPACK FOOTER //
// src/page/index/activity.vue